// extracted by mini-css-extract-plugin
export var actionButton = "_l9-t";
export var buttonContainer = "_l9-0";
export var buttonContainer2 = "_l9-1";
export var buttonSection = "_l9-2";
export var details = "_l9-3";
export var dropdownItem = "_l9-5";
export var dropdownItemsContainer = "_l9-4";
export var fileInput = "_l9-r";
export var headerButton = "_l9-6";
export var icon = "_l9-7";
export var input = "_l9-8";
export var macroListItem = "_l9-9";
export var mainContent = "_l9-a";
export var microText = "_l9-b";
export var modal = "_l9-w";
export var optionsButton = "_l9-c";
export var paperclip = "_l9-s";
export var pillContent = "_l9-d";
export var preview = "_l9-e";
export var preview2 = "_l9-f";
export var quillEditor = "_l9-q";
export var selectedMacro = "_l9-g";
export var sidebar = "_l9-h";
export var sidebarHeader = "_l9-j";
export var sidebarList = "_l9-i";
export var sidebarListItem = "_l9-k";
export var sidebarSearch = "_l9-l";
export var snoozeDurationWrapper = "_l9-v";
export var statusPillContainer = "_l9-m";
export var tagsContainer = "_l9-n";
export var unselectedMacro = "_l9-o";
export var variable = "_l9-u";
export var wrapper = "_l9-p";